<template>
  <main class="pt-16 bg-gradient-to-b from-gray-100 via-gray-200 to-gray-100">
    <div class="w-full py-8 lg:py-16">
      <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 class="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-6 sm:mb-8 text-center sm:text-left">
          Contactez-nous
        </h1>

        <div class="bg-white rounded-lg shadow-md p-4 sm:p-6 lg:p-8">
          <form @submit.prevent="submitForm">
            <!-- Nom et Prenom -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
              <!-- Nom -->
              <div>
                <label
                  for="nom"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  Nom *
                </label>
                <input
                  type="text"
                  id="nom"
                  v-model="form.nom"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                  placeholder="Votre nom"
                />
              </div>

              <!-- Prenom -->
              <div>
                <label
                  for="prenom"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  Prenom *
                </label>
                <input
                  type="text"
                  id="prenom"
                  v-model="form.prenom"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                  placeholder="Votre prenom"
                />
              </div>
            </div>

            <!-- Email et Telephone -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
              <!-- Email -->
              <div>
                <label
                  for="email"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  v-model="form.email"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                  placeholder="votre@email.com"
                />
              </div>

              <!-- Telephone -->
              <div>
                <label
                  for="telephone"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  Telephone
                </label>
                <input
                  type="tel"
                  id="telephone"
                  v-model="form.telephone"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                  placeholder="06 12 34 56 78"
                />
              </div>
            </div>

            <!-- Sujet -->
            <div class="mb-4 sm:mb-6">
              <label
                for="sujet"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                Sujet *
              </label>
              <select
                id="sujet"
                v-model="form.sujet"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
              >
                <option value="">Selectionnez un sujet</option>
                <option value="offre">Question sur l'offre</option>
                <option value="participation">Suivi de participation</option>
                <option value="autre">Autre</option>
              </select>
            </div>

            <!-- Objet -->
            <div class="mb-4 sm:mb-6">
              <label
                for="objet"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                Objet *
              </label>
              <input
                type="text"
                id="objet"
                v-model="form.objet"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                placeholder="Objet de votre message"
              />
            </div>

            <!-- Message -->
            <div class="mb-4 sm:mb-6">
              <label
                for="message"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                Message *
              </label>
              <textarea
                id="message"
                v-model="form.message"
                required
                rows="5"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors resize-none"
                placeholder="Votre message..."
              ></textarea>
            </div>

            <!-- Message d'erreur -->
            <div
              v-if="error"
              class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm"
            >
              {{ error }}
            </div>

            <!-- Bouton submit -->
            <button
              type="submit"
              :disabled="loading"
              class="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300 text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center"
            >
              <span v-if="loading" class="flex items-center gap-2">
                <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Envoi en cours...
              </span>
              <span v-else>Envoyer le message</span>
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal de confirmation -->
    <transition name="popup-fade">
      <div
        v-if="showSuccessModal"
        class="fixed inset-0 z-[100] flex items-center justify-center"
      >
        <!-- Overlay -->
        <div
          class="absolute inset-0 bg-black bg-opacity-50"
          @click="closeModal"
        ></div>

        <!-- Modal -->
        <transition name="popup-scale" appear>
          <div
            v-if="showSuccessModal"
            class="relative bg-white rounded-lg shadow-xl max-w-sm w-full mx-4 p-8 text-center"
          >
        <!-- Checkmark anime -->
        <div class="mb-6">
          <div
            class="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center"
          >
            <svg
              class="w-12 h-12 text-green-500 checkmark-animation"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
                d="M5 13l4 4L19 7"
                class="checkmark-path"
              />
            </svg>
          </div>
        </div>

        <!-- Texte -->
        <h2 class="text-xl font-bold text-gray-900 mb-3">Message envoye !</h2>
        <p class="text-gray-600 text-sm mb-6">
          Votre message a bien ete pris en compte. Nous vous repondrons dans les
          plus brefs delais.
        </p>

        <!-- Bouton fermer -->
            <button
              @click="closeModal"
              class="bg-black hover:bg-gray-800 text-white font-semibold py-3 px-8 rounded-lg transition-colors"
            >
              Fermer
            </button>
          </div>
        </transition>
      </div>
    </transition>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "ContactView",
  data() {
    return {
      form: {
        nom: "",
        prenom: "",
        email: "",
        telephone: "",
        sujet: "",
        objet: "",
        message: "",
      },
      showSuccessModal: false,
      loading: false,
      error: "",
    };
  },
  methods: {
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    async submitForm() {
      this.error = "";

      // Validation
      if (!this.form.nom || !this.form.prenom || !this.form.email || !this.form.sujet || !this.form.objet || !this.form.message) {
        this.error = "Veuillez remplir tous les champs obligatoires.";
        return;
      }

      if (!this.validateEmail(this.form.email)) {
        this.error = "Veuillez entrer une adresse email valide.";
        return;
      }

      this.loading = true;

      try {
        await axios.post(
          "https://api-gabarit.promo.dev/api/operations-custom/promodev-send-contact/sendmail",
          {
            operationId: "691aec3fe85184ee57dbd4c4",
            nom: this.form.nom,
            prenom: this.form.prenom,
            email: this.form.email,
            demande: this.form.sujet,
            objet: this.form.objet,
            message: this.form.message,
          }
        );

        // Reset du formulaire
        this.form = {
          nom: "",
          prenom: "",
          email: "",
          telephone: "",
          sujet: "",
          objet: "",
          message: "",
        };

        // Afficher la modal
        this.showSuccessModal = true;
      } catch (err) {
        console.error("Erreur lors de l'envoi:", err);
        this.error = "Une erreur est survenue lors de l'envoi du message. Veuillez réessayer.";
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.showSuccessModal = false;
    },
  },
};
</script>

<style scoped>
.checkmark-path {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  animation: checkmark-draw 0.6s ease-out 0.2s forwards;
}

@keyframes checkmark-draw {
  to {
    stroke-dashoffset: 0;
  }
}

.checkmark-animation {
  animation: checkmark-scale 0.3s ease-out;
}

@keyframes checkmark-scale {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Popup animations */
.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 0.3s ease;
}

.popup-fade-enter,
.popup-fade-leave-to {
  opacity: 0;
}

.popup-scale-enter-active {
  animation: popup-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.popup-scale-leave-active {
  animation: popup-out 0.25s ease-in;
}

@keyframes popup-in {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes popup-out {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
}
</style>
